export const LiveSessionListRouteParamIds = {
  SESSION_ID: 'sid',
  PARTICIPANT_ID: 'pid',
  MATCH_ID: 'mid',
} as const;

export const LiveSessionListRouteNames = {
  HOST: '',
  NEW_SESSION: `new`,
  DATA_SYNC: `sync`,
  RUNNING_SESSION: `overview`,
} as const;
